import { ComingNomenclatureFare, ComingNomenclatureSalaryRequest } from 'bus/comingNomenclatureMain/types';

import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../../api';
import { DriverMixerSalaryItem, DriverMixerSalaryItemCreate } from '../types';

const driverMixerSalary = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriverMixerSalary: builder.query<DriverMixerSalaryItem, PayloadRequest>({
      query: () => ({
        url: '/v1/DriverMixerSalary/configuration',
      }),
    }),
    getDriverMixerSalaryDetail: builder.query<DriverMixerSalaryItemCreate, PayloadRequest>({
      query: (data) => ({
        url: `/v1/DriverMixerSalary/configuration/${data.id}`,
      }),
    }),
    changeDriverMixerSalary: builder.mutation<void, DriverMixerSalaryItemCreate>({
      query: (data) => ({
        url: `/v1/DriverMixerSalary/configuration/${data.id}`,
        method: 'PUT',
        body: data,
      }),
    }),
    createDriverMixerSalary: builder.mutation<void, DriverMixerSalaryItemCreate>({
      query: (data) => ({
        url: '/v1/DriverMixerSalary/configuration',
        method: 'POST',
        body: data,
      }),
    }),
    deleteDriverMixerSalary: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/DriverMixerSalary/configuration/${data.id}`,
        method: 'DELETE',
      }),
    }),
    getDriverMixerSalaryDetails: builder.query<ComingNomenclatureFare, ComingNomenclatureSalaryRequest>({
      query: (data) => ({
        url: `/v1/driverMixerSalary/${data.driverId}/details`,
        params: data,
      }),
    }),
  }),
});

export const {
  useChangeDriverMixerSalaryMutation,
  useCreateDriverMixerSalaryMutation,
  useGetDriverMixerSalaryDetailQuery,
  useGetDriverMixerSalaryQuery,
  useLazyGetDriverMixerSalaryDetailQuery,
  useLazyGetDriverMixerSalaryQuery,
  useDeleteDriverMixerSalaryMutation,
  useLazyGetDriverMixerSalaryDetailsQuery,
  useGetDriverMixerSalaryDetailsQuery,
} = driverMixerSalary;
